import React, { ReactElement } from 'react'
import { LanguageMyReportList } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import IconButton, { IconButtonType } from '../../Common/Components/IconButton'

import { IconName } from '../../Common/Components/Icon'
import DefaultReportMenu from './DefaultReportMenu'
import { OptionsMenuAdapter } from '../../Common/Components/OptionsMenu/OptionsMenu'
import { useReportPortalContainer } from '../../Common/Hooks/useReportPortalContainer'
import { announceOptionsMenuClose } from '../../../NonReact/common/RxJS/RowMenuState'
import { LanguageContextProvider, PromptContextProvider } from '../../Common/Contexts'
import { EventNames } from '../../../NonReact/constants/EventNames'
/**
 * Component properties type.
 */
type Props = {
    isReportExist: boolean
    initialiseReportListData: () => Promise<void>
    isReportTemplateUser: boolean
}

/**
 * Adapter to create a default report menu
 * @param isReportExist Flag to check whether reports already exist or not.
 * @param initialiseReportListData Report list data initialisation method.
 * @returns
 */
const DefaultReportMenuAdapter: React.FC<Props> = ({
    isReportExist,
    initialiseReportListData,
    isReportTemplateUser
}: Props): ReactElement => {
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    language.loadBundle('LanguagePrompt')
    language.loadBundle('LanguageMyReportList')

    /** Method to close menu when mouse down click happen.
     *
     * @param e click event
     */
    const closeMenuEvent = (e: Event): void => {
        if (!e.cancelBubble) {
            announceOptionsMenuClose()
            document.removeEventListener(EventNames.MOUSEDOWN, closeMenuEvent)
        }
    }

    /**
     * Method to show the default reports menu
     * @param event
     */
    const openDefaultReportMenu = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        const element: ReactElement = (
            <LanguageContextProvider>
                <PromptContextProvider>
                    <DefaultReportMenu
                        isReportExist={isReportExist}
                        initialiseReportListData={initialiseReportListData}
                    />
                </PromptContextProvider>
            </LanguageContextProvider>
        )

        OptionsMenuAdapter.newInstance(event, element, useReportPortalContainer())

        document.addEventListener(EventNames.MOUSEDOWN, closeMenuEvent)
    }

    return !isReportTemplateUser ? (
        <a onClick={openDefaultReportMenu}>
            <div className='hidden-visibility'>
                <IconButton
                    customClassName='add-default-report-button'
                    iconName={IconName.LIBRARY_ADD_OUTLINED}
                    title={language.get(LanguageMyReportList.ReportlistAdddefaultreport)}
                    type={IconButtonType.BUTTON}
                />
            </div>
        </a>
    ) : (
        <></>
    )
}

export default DefaultReportMenuAdapter
